/*=========================================================================================
  File Name: moduleProduct.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleProductState.js";
import mutations from "./moduleProductMutations.js";
import actions from "./moduleProductActions.js";
import getters from "./moduleProductGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters,
};
